import { getPrompts } from '../../api';
import { useListFetch } from '../../hooks';
import type { PromptsItem, GetPromptsFilters } from '../../api';
import type { PromptUpdatePayload, PromptCreatePayload } from '../../api';

export const usePrompts = (campaignId: string) => {
  return useListFetch<PromptsItem, GetPromptsFilters>(
    async params => {
      if (!params.filters?.campaignId) return { content: [] };

      const result = await getPrompts(params?.filters, params?.pagination);
      return { content: result };
    },
    {
      initialFilters: { promptType: '', campaignId },
      withQueryParams: true,
    }
  );
};

export type Item = PromptsItem;
export type FormType = Partial<PromptsItem>;
export type CreateItem = PromptCreatePayload;
export type UpdateItem = PromptUpdatePayload;
